import React, { useEffect, useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { ThemeContext } from "../Homepage";
import { useContext } from "react";
import { Typography } from "@mui/material";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import CustomCheckbox from "./CustomCheckbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

// const data = [
//   'Oliver Hansen',
//   'Van Henry',
//   'April Tucker',
//   'Ralph Hubbard',
//   'Omar Alexander',
//   'Carlos Abbott',
//   'Miriam Wagner',
//   'Bradley Wilkerson',
//   'Virginia Andrews',
//   'Kelly Snyder',
// ];

export default function CustomMultiselectWithCheckbox({
  options,
  onChange,
  selecteddata,
  width,
  fontSize,
  disabled,
  maxLimit,
}) {
  const { theme } = useContext(ThemeContext);

  const [selectedValue, setselectedValue] = React.useState(selecteddata);

  // useEffect(()=>{
  //   selected(selectedValue);
  // },[selectedValue])

  // useEffect(()=>{
  //   setselectedValue(selecteddata);
  // },[])

  //    useEffect(()=>{
  //   if(selecteddata!=-1){
  //   selectedValue.splice(selecteddata,1);
  //   setselectedValue(selectedValue);
  //   }
  // },[selecteddata])

  
  useEffect(()=>{
    setselectedValue(selecteddata);
  },[selecteddata])


  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    onChange(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleOnCheck = (event) => {
    // const {target: { value },} = event;
    // onChange(
    //   // On autofill we get a stringified value.
    //   typeof value === 'string' ? value.split(',') : value,
    // );
  };

  return (
    <div>
      <FormControl sx={{ display: "flex" }}>
        {/* <InputLabel shrink={false} >select from plantview</InputLabel> */}
        <Select
          variant="standard"
          defaultValue="Year"
          //id="demo"
          multiple
          value={selectedValue.length !== 0 ? selectedValue : selecteddata}
          onChange={handleChange}
          //input={<OutlinedInput label="Tag" />}
          renderValue={(onChange) => onChange.join(", ")}
          disabled={disabled ? true : false}
          //   sx={{border:0,
          //     width:'224px',
          //     //height: '24px',
          //     bgcolor:'var(--SecondaryBackground)',
          //     color:'var(--GreyVariation_2)',
          //     fontSize:'18px',
          //     fontFamily:'Roboto',
          //     fontWeight:400,
          //     textAlign:'left',
          //     borderRadius:0,
          //     marginRight:'0px',
          //     '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':{
          //         border:0,
          //     },
          //     '& .MuiOutlinedInput-notchedOutline ': {
          //         width:'122.35px',
          //         //height:'24px',
          //         border:0,
          //         padding:0
          //     },
          //     '& .MuiInputLabel-root':{display:'none',legend:'none'}
          // }}
          disableUnderline={disabled != null ? disabled : false}
          IconComponent={(props) => (
            <ExpandMoreOutlinedIcon style={{ width: "16px", height: "16px" }} />
          )}
          sx={{
            border: 0,
            width: width ? width : "224px",
            //height: '24px',
            bgcolor: "none",
            color: "var(--GreyVariation_2)",
            fontSize: fontSize ? `${fontSize}px` : "18px",
            fontFamily: "Roboto",
            fontWeight: 400,
            textAlign: "left",
            borderRadius: 0,
            marginRight: "0px",
            marginTop: "0px",
            "& .Mui-disabled": {
              borderBottom: "1px solid",
              borderBottomColor: theme === "light" ? "#C1C1C1" : "#3C3C3C",
              WebkitTextFillColor: theme === "light" ? "#C1C1C1" : "#3C3C3C",
            },
            "& .MuiSvgIcon-root": {
              fill:
                (disabled != null ? disabled : false) == true
                  ? theme === "light"
                    ? "#C1C1C1"
                    : "#3C3C3C"
                  : "var(--GreyVariation_2)",
              //borderBottom: '1px solid var(--GreyVariation_2)',
            },
            // '& .MuiInputBase-root.MuiInput-root.MuiSelect-root.Mui-disabled':{color:"pink"},
            //':before': { borderBottom: '1px solid var(--GreyVariation_2)' ,borderBottomColor:(disabled!=null?disabled:false)==true?theme === 'light' ? '#C1C1C1' : '#3C3C3C' :'var(--GreyVariation_2)'},
            ":before": {
              borderBottom:
                theme === "light" ? "1px solid #3C3C3C" : "1px solid #C1C1C1",
            },
            ":after": { borderBottom: "2px solid #008CD7" },
            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
            "& .MuiOutlinedInput-notchedOutline ": {
              width: "122.35px",
              //height:'24px',
              border: 0,
              padding: 0,
            },
            "& .MuiInputLabel-root": { display: "none", legend: "none" },
            "& .MuiSelect-select": {
              paddingTop: "0px",
              paddingBottom: "0px",
              marginTop: "0px",
            },
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: theme === "light" ? "#C1C1C1" : "#3C3C3C",
              //WebkitBorderFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',
            },
            // '& .MuiInput-underline:before': {
            //     borderBottom: theme === 'light' ? '#C1C1C1' : '#3C3C3C',
            //     //WebkitBorderFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',
            // },
          }}
          InputLabelProps={{ shrink: false }}
          MenuProps={{
            PaperProps: {
              sx: {
                bgcolor: theme === "dark" ? "#3C3C3C" : "#C1C1C1",
                borderBottom: "2px solid #008CD7",
                borderRadius: 0,
                boxShadow: "none",
                width: width ? width : "224px",
                maxHeight: "250px",
                overflow: "auto",
                color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
                // '&::-webkit-scrollbar': {
                //   width: '30px'
                // },
                "&::-webkit-scrollbar": {
                  width: "4px",
                  height: "4px",
                },

                /* Track */
                "&::-webkit-scrollbar-track": {
                  /*box-shadow: inset 0 0 5px grey,*/
                  borderRadius: "0px",
                  background: theme === "light" ? "#ffffff" : "#1e1e1e",
                  margin: "4px 0px 4px 0px",
                },

                /* Handle */
                "&::-webkit-scrollbar-thumb": {
                  background: "#008CD7",
                  borderRadius: "5px",
                },
                "& .MuiList-root.MuiMenu-list": {
                  padding: "4px 0px 4px 0px",
                },
                "& .MuiMenuItem-root.Mui-selected": {
                  //background: "#005C8E",
                  fontWeight: 700,
                  color: "#000000",
                },
                "& .MuiMenuItem-root:hover": {
                  backgroundColor: "#005C8E",
                  color: "#000000",
                },
              },
            },
          }}
        >
          {options.map((val) => (
            <MenuItem
              key={val}
              value={val}
              disabled={
                selecteddata.length >= maxLimit && !selecteddata.includes(val)
              }
              sx={{ padding: "6px 8px", gap: "2px" }}
            >
              {/* <Checkbox checked={selecteddata.indexOf(val) > -1}
               sx={{
                  padding: 0,
                  margin: 0,
                  color: 'var(--HighlightedText_Stroke)',
                  '& .MuiSvgIcon-root': {
                      fontSize: '20px',
                      color: 'var(--HighlightedText_Stroke)'
                  }
              }}/> */}
              <CustomCheckbox
                defaultChecked={selecteddata.indexOf(val) > -1}
                checked={selecteddata.indexOf(val) > -1}
                onChange={handleOnCheck}
                width={14}
                height={14}
              />
              <Typography noWrap style={{ marginLeft: "4px" }}>
                {val}
              </Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
